import { createRouter, createWebHistory } from 'vue-router'
import HomeView from '../components/HomeView.vue'
import LocationPage from '../components/site/LocationPage.vue'
import locations from '../data/locations.js'

const locationRoutes = locations.map((loc) => ({
  path: `/laptop-repair-${loc.slug}`,
  name: `location-${loc.slug}`,
  component: LocationPage,
  props: { location: loc }
}))

const routes = [
  { path: '/', name: 'home', component: HomeView },
  ...locationRoutes
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
  scrollBehavior() {
    return { top: 0 }
  }
})

export default router
